import {NavLink} from 'react-router-dom';

import {
    Box,
    Breadcrumbs,
} from '@mantine/core';
import {Contact} from '../types';
import {config} from "../config";

export const EditPageNavigation = ({component}: { component: Contact }) => {

    const breadcrumbs = [
        {
            title: config.titles.plural,
            href: `/contacts`,
        },
        {title: component.firstName && component.lastName ? `${component.firstName} ${component.lastName}` : component.email || component.id}].map((item, index) => (
        <Box key={index}> {
            item
                .href ?
                <NavLink to={item.href}>{item.title}</NavLink> : item.title
        }
        </Box>
    ));

    return (
        <Box p={'xs'}><Breadcrumbs separator='→' mt='xs'>{breadcrumbs}</Breadcrumbs></Box>
    );
};
